import { Link } from "react-router-dom";

const SECTIONS = [
  {
    number: "1",
    title: "Legal Status & Non-Financial Institution Declaration",
    content: [
      {
        subtitle: "NGO Status",
        text: "Revolutionary Foundation is registered as a Non-Governmental Organization (NGO) focused on humanitarian impact under the laws of the Federal Republic of Nigeria.",
      },
      {
        subtitle: "Not a Financial Institution",
        text: "The Foundation is not a bank, microfinance house, insurance company, or investment firm. We do not provide traditional banking services, loans with interest, or financial investment schemes.",
      },
      {
        subtitle: "Nature of Payments",
        text: "All financial disbursements are classified as grants, humanitarian aid, or personal support, and are not to be mistaken for commercial financial products. The ₦250 membership fee is a one-time administrative contribution and not a financial deposit.",
      },
    ],
  },
  {
    number: "2",
    title: "Funding Limitations & Disbursement Policy",
    content: [
      {
        subtitle: "Source of Funds",
        text: "The Foundation operates primarily on funds gathered through corporate sponsorships, private donations, membership contributions, and organized fundraising events.",
      },
      {
        subtitle: "Contingency Clause",
        text: "Disbursement of funds for projects or personal beneficiary support is strictly subject to the availability of funds. The Foundation is not legally obligated to provide financial support if fundraising targets are not met or if sponsors fail to fulfill their pledges.",
      },
      {
        subtitle: "Distribution",
        text: "While we have successfully disbursed over ₦4.5 Billion Naira since 2019, future disbursements are at the sole discretion of the Board of Trustees based on the current resource pool and the merit of each application.",
      },
    ],
  },
  {
    number: "3",
    title: "Intermediary & Brokerage Roles",
    content: [
      {
        subtitle: "Intermediary Function",
        text: "Revolutionary Foundation acts as a professional intermediary between: Philanthropists and vetted beneficiaries; Government Agencies and local communities; Other NGOs and project-specific stakeholders.",
      },
      {
        subtitle: "Grant Management",
        text: "When the Foundation facilitates grants from third-party donors (philanthropists or government bodies), we act as the implementing partner. We ensure that the donor's requirements are met and that funds reach registered members or target projects effectively.",
      },
      {
        subtitle: "Due Diligence",
        text: "The Foundation maintains a rigorous vetting process for all third-party grants to ensure transparency and accountability in line with international best practices.",
      },
    ],
  },
  {
    number: "4",
    title: "Operational Model & Partnerships",
    content: [
      {
        subtitle: "Head Office & Regional Outreach",
        text: "While our primary administrative operations are based in Nigeria, we maintain the right to partner with localized NGOs across the 36 states to execute projects.",
      },
      {
        subtitle: "African Expansion",
        text: "Members acknowledge that as we expand into other African countries, the Foundation may act as an intermediary for international donor agencies seeking to reach the African continent.",
      },
    ],
  },
  {
    number: "5",
    title: "Membership Registration & Eligibility",
    content: [
      {
        subtitle: "Mandatory Membership",
        text: "To participate in any intermediary grant programs or receive funds gathered from sponsors, individuals and organizations must be registered members with a confirmed ₦250 membership payment.",
      },
      {
        subtitle: "Verification",
        text: "The Foundation reserves the right to verify the identity and status of any member before facilitating a third-party grant or disbursement. Members must provide accurate information during registration.",
      },
      {
        subtitle: "Membership Fee",
        text: "The ₦250 one-time membership fee is non-refundable once paid. This fee contributes to the general grant fund pool and administrative operations of the Foundation.",
      },
      {
        subtitle: "Eligibility Age",
        text: "Members must be at least 18 years of age or represent a legally registered organization to qualify for membership and grant programs.",
      },
    ],
  },
  {
    number: "6",
    title: "Grant Application Terms",
    content: [
      {
        subtitle: "Application Accuracy",
        text: "All information provided in grant applications must be accurate and truthful. Submission of false or misleading information will result in immediate disqualification and potential legal action.",
      },
      {
        subtitle: "No Guarantee of Funding",
        text: "Submission of a grant application does not guarantee funding. All applications are evaluated on merit, availability of funds, and alignment with the Foundation's objectives.",
      },
      {
        subtitle: "Bank Account Details",
        text: "Members must provide accurate bank account details for disbursement. The Foundation is not responsible for failed transfers resulting from incorrect account information provided by the applicant.",
      },
    ],
  },
  {
    number: "7",
    title: "Data Privacy & Protection",
    content: [
      {
        subtitle: "Data Collection",
        text: "We collect personal data including name, email, phone number, organization details, and bank account information solely for the purpose of membership management and grant disbursement.",
      },
      {
        subtitle: "Data Security",
        text: "All personal data is stored securely on Firebase (Google Cloud) infrastructure with bank-level encryption. Payment data is processed exclusively by Korapay and is never stored on our servers.",
      },
      {
        subtitle: "Data Sharing",
        text: "We do not sell or share your personal data with third parties except where required by Nigerian law or for the purpose of processing your grant application with partner organizations.",
      },
    ],
  },
  {
    number: "8",
    title: "Governing Law",
    content: [
      {
        subtitle: "Nigerian Law",
        text: "These terms are governed by the laws of the Federal Republic of Nigeria, including regulations set by the Corporate Affairs Commission (CAC) and the Special Control Unit against Money Laundering (SCUML).",
      },
      {
        subtitle: "Dispute Resolution",
        text: "Any disputes arising from these terms shall first be resolved through mediation by the Foundation's Board of Trustees. If unresolved, disputes shall be settled in the Federal High Court of Nigeria.",
      },
    ],
  },
  {
    number: "9",
    title: "Amendments",
    content: [
      {
        subtitle: "Right to Amend",
        text: "Revolutionary Foundation reserves the right to amend these Terms and Conditions at any time. Members will be notified of significant changes via email and through the member dashboard. Continued use of our services after notification constitutes acceptance of the revised terms.",
      },
    ],
  },
];

export default function TermsPage() {
  return (
    <>
      <style>{`
        .terms-hero { background:linear-gradient(160deg,#071428,#0B1F3A,#122844); padding:140px 5vw 80px; text-align:center; }
        .terms-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(36px,5vw,60px); font-weight:900; color:white; margin-bottom:18px; }
        .terms-body { max-width:860px; margin:0 auto; padding:72px 5vw 100px; }
        .terms-section { margin-bottom:48px; }
        .terms-num { font-family:'Playfair Display',serif; font-size:13px; color:var(--gold); font-weight:700; letter-spacing:1px; text-transform:uppercase; margin-bottom:8px; }
        .terms-title { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:var(--navy); margin-bottom:20px; padding-bottom:12px; border-bottom:2px solid var(--gold-pale); }
        .terms-item { margin-bottom:18px; }
        .terms-subtitle { font-size:14px; font-weight:700; color:var(--navy); margin-bottom:6px; }
        .terms-text { font-size:14px; color:var(--text-muted); line-height:1.85; }
        .terms-toc { background:var(--off-white); border:1px solid var(--border-light); padding:28px 32px; margin-bottom:48px; border-radius:4px; }
        .terms-toc h3 { font-family:'Playfair Display',serif; font-size:18px; color:var(--navy); margin-bottom:16px; }
        .terms-toc a { display:block; font-size:13px; color:var(--gold); padding:4px 0; transition:color 0.2s; }
        .terms-toc a:hover { color:var(--navy); }
        .terms-footer { background:var(--off-white); border:1px solid var(--border-light); padding:24px 28px; border-radius:4px; margin-top:48px; }
      `}</style>

      {/* HERO */}
      <section className="terms-hero">
        <span className="section-eyebrow" style={{ color: "#E8B96A" }}>Legal</span>
        <h1>Terms &<br /><em style={{ fontStyle: "italic", color: "#E8B96A" }}>Conditions</em></h1>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 16, maxWidth: 520, margin: "0 auto" }}>
          Please read these terms carefully before registering or applying for grants through Revolutionary Foundation.
        </p>
        <div style={{ display: "inline-block", background: "rgba(255,255,255,0.08)", padding: "8px 20px", borderRadius: 4, marginTop: 20 }}>
          <span style={{ fontSize: 13, color: "rgba(255,255,255,0.6)" }}>Last updated: January 2025</span>
        </div>
      </section>

      <div className="terms-body">
        {/* TABLE OF CONTENTS */}
        <div className="terms-toc">
          <h3>Table of Contents</h3>
          {SECTIONS.map(s => (
            <a key={s.number} href={`#section-${s.number}`}>
              {s.number}. {s.title}
            </a>
          ))}
        </div>

        {/* INTRO */}
        <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, marginBottom: 48, padding: "20px 24px", background: "rgba(201,150,62,0.04)", border: "1px solid rgba(201,150,62,0.15)", borderRadius: 4 }}>
          By registering as a member or applying for grants through Revolutionary Foundation, you confirm that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you should not register or use our services.
        </p>

        {/* SECTIONS */}
        {SECTIONS.map(s => (
          <div className="terms-section" key={s.number} id={`section-${s.number}`}>
            <div className="terms-num">Section {s.number}</div>
            <div className="terms-title">{s.title}</div>
            {s.content.map(item => (
              <div className="terms-item" key={item.subtitle}>
                <div className="terms-subtitle">{item.subtitle}</div>
                <div className="terms-text">{item.text}</div>
              </div>
            ))}
          </div>
        ))}

        {/* FOOTER */}
        <div className="terms-footer">
          <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 17, color: "var(--navy)", fontWeight: 700, marginBottom: 10 }}>
            Contact Us About These Terms
          </div>
          <div style={{ fontSize: 14, color: "var(--text-muted)", lineHeight: 1.8 }}>
            If you have questions about these Terms and Conditions, please contact our legal team:<br />
            📧 <strong>revfoundationsupport</strong>
          </div>
          <div style={{ marginTop: 20, display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Link to="/membership" className="btn-primary" style={{ fontSize: 13, padding: "10px 20px" }}>Join as Member →</Link>
            <Link to="/contact" className="btn-outline-dark" style={{ fontSize: 13, padding: "10px 20px" }}>Contact Us</Link>
          </div>
        </div>
      </div>
    </>
  );
}
